import React, { useState } from 'react'
import { useGetCategoriesQuery } from '../../../hooks/library/useGetCategoriesQuery';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../routes';
import { BookType } from '../../../types/Library';
import { useAppDispatch } from '../../../hooks/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { updateCategory } from '../../../services/library/category';
import { key_books, key_categories } from '../../../utils/constants';
import toast from 'react-hot-toast';
import { setCategoryData } from '../../../redux/slices/library/category';
import { ArrowRightIcon, Pencil1Icon, PlusIcon, TrashIcon } from '@radix-ui/react-icons';
import { ConfirmAlertDialog } from '../../../components/common/ConfirmAlertDialog';
import TableComponent from '../../../components/common/Tables';
import { Lists } from '../../../components/common/Lists';
import { useGetBooksQuery } from '../../../hooks/library/useGetBooksQuery';
import { setBookData } from '../../../redux/slices/library/book';
import { updateBook } from '../../../services/library/book';
import { setPreviousPath } from '../../../redux/slices/previousPath';

const columnNamesMap: { [key: string]: string } = {
    title: 'Titulo',
    category: 'Categoria',
    copies: 'Copias',
};

export const Books = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItem, setDeleteItem] = useState<BookType | null>(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { data, status } = useGetBooksQuery({ PageNumber: currentPage, PageSize: 10 });
    const mutationUpdate = useMutation(updateBook, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_books);
            toast.success('Livro eliminado');
        },
        onError: () => {
            toast.error("Erro ao eliminar o livro.")
        }
    });
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createBook);
    }
    const handleDelete = (c: BookType) => {
        c.status = false;
        mutationUpdate.mutateAsync(c)
      };
      const openDeleteDialog = (s: BookType) => {
        setDeleteItem(s);
      };  
      const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
      };
      const handleEdit = (c: BookType) => {
        dispatch(setBookData(c));
        navigate(routes.updateBook)
      };
      const handleClickLoan = (c: BookType) => {
        if(c.copies==0){
            toast.error("Sem unidades disponiveis");
            return;
        }
        dispatch(setBookData(c));
        dispatch(setPreviousPath(routes.books));
        navigate(routes.createLoan)
      };

      const handleAddAuthors = (c: BookType) => {
        dispatch(setBookData(c));
        dispatch(setPreviousPath(routes.books));
        navigate(routes.manageBookAuthors)
      };
      const options = data?.items.map((c: BookType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(c),
            icon: <Pencil1Icon />
        },
        {
            label: 'Adicionar autores',
            onClick: () => handleAddAuthors(c),
            icon: <PlusIcon />
        },
        {
            label: 'Emprestar',
            onClick: () => handleClickLoan(c),
            icon: <ArrowRightIcon />
        },
        {
            label: 'Eliminar',
            onClick: () => openDeleteDialog(c),
            icon: <TrashIcon />
        }
      ]) || [];
      return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        emptyMessage="Ainda não existem livros registados."
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                description="O livro deixará de estar disponível na biblioteca. Pretende continuar?"
                confirmLabel="Eliminar"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
      );
}
